<template>
  <v-snackbar
    v-model="visible"
    :timeout="-1"
    bottom
    right
    multi-line
    max-width="520"
    class="cookie-notice"
  >
    {{ $t('Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.') }}
    <template #action="{ attrs }">
      <v-btn
        color="primary"
        v-bind="attrs"
        @click="accept"
      >
        {{ $t('Хорошо') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { ref } from '@vue/composition-api'

// Уведомление о сборе cookie — требование закона. Ответ клиента храним в
// памяти браузера: серверу о нём знать незачем, а после согласия плашка
// больше не показывается.
const STORAGE_KEY = 'cookie_notice_accepted'

export default {
  setup() {
    const visible = ref(localStorage.getItem(STORAGE_KEY) !== '1')

    const accept = () => {
      localStorage.setItem(STORAGE_KEY, '1')
      visible.value = false
    }

    return { visible, accept }
  },
}
</script>
